import React, { useState, useEffect } from 'react';
import axios from "axios";
import NavbarComponent from './Components/NavbarComponent';
import MainSlider from './Components/LandingSlider';
import Insight from './Components/Insight';
import OurExpertise from './Components/OurExpertise';
import About from './Components/AboutUs';
import Footer from './Components/Footer';
import API_URLS from './Components/apiConfig';
import { height } from '@fortawesome/free-solid-svg-icons/fa0';

const Home = () => {
  const [activeSection, setActiveSection] = useState('');
  const [homePageData, setHomePageData] = useState(null);
  const baseUrl=API_URLS.baseUrl;
  const homeUrl=API_URLS.baseFrontUrl;

    // useEffect(() => {
    //   const fetchData = async () => {
    //     const response = await fetch('https://api.example.com/data');
    //     const result = await response.json();
    //     setData(result);
    //   };
  
    //   fetchData();
    // }, []); // Empty array means this effect runs only once

  useEffect(() => {
    const fetchData = async () => {
      axios
        .get(API_URLS.getHomePage)
        .then((response) => {
          if (response.data) {
            setHomePageData(response.data.acf);
            //console.log("ok2"+response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching menu data:", error);
        });
    };
    fetchData();  
  }, []);

  useEffect(() => {
    // Scroll to the top of the page on load
    window.scrollTo(0, 0);

    // Select all sections with an id attribute
    const sections = document.querySelectorAll('div[id]');

    const observerOptions = {
      root: null, // Use the viewport as the root
      rootMargin: '0px',
      threshold: 0.5, // Trigger when 50% of the section is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id); // Update activeSection when a section becomes visible
        }
      });
    }, observerOptions);

    sections.forEach((section) => observer.observe(section)); // Observe all sections

    return () => observer.disconnect(); // Cleanup the observer
  }, []);

  if (!homePageData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <NavbarComponent activeSection={activeSection} />
      <div id="slider-section">
        <MainSlider dataLandingSlider={homePageData.banner} />
      </div>
      <div id="OurExpertise">
        <OurExpertise dataOurExpertise={homePageData.expertise} url={baseUrl} homeurl={homeUrl} />
      </div>
      <div id="Insight">
        <Insight dataOurInsight={homePageData.insight} url={baseUrl} homeurl={homeUrl} />
      </div>
      <div id="about-section">
        <About dataAbout={homePageData.wordlide} url={baseUrl} homeurl={homeUrl} />
      </div>
      <div id="footer-section">
        <Footer />
      </div>
    </div>
  );
};

export default Home;
